import {IS_PADDLE_IN_PRODUCTION, IS_PAID_IN_PRODUCTION} from "@/common/utils";
import paddleTestStore from "@/app/api/store/paddle-test-store";
import paddleProdStore from "@/app/api/store/paddle-prod-store";

const store = (IS_PAID_IN_PRODUCTION && IS_PADDLE_IN_PRODUCTION) ?
    paddleProdStore :
    paddleTestStore;

export default store;
